/**
 * Created by Darius on 2016.08.07.
 */
import React, {Component} from "react";
import ReactQuill from "react-quill";

const toolbarItems = ReactQuill.Toolbar.defaultItems;
toolbarItems.push(
    {
        label: 'Placeholders',
        type: 'group',
        items: [
            {
                type: 'background',
                label: 'Placeholders',
                items: [
                    {label: "Insert Placeholder", value: ""},
                    {label: "First Name", value: "{{FirstName}}"},
                    {label: "Last Name", value: "{{LastName}}"},
                    {label: "Reporter", value: "{{Reporter}}"},
                    {label: "Account Num", value: "{{AccountNum}}"},
                    {label: "NickName", value: "{{NickName}}"},
                    {label: "Email", value: "{{Email}}"},
                    {label: "Transport", value: "{{Transport}}"},
                    {label: "Address1", value: "{{Address1}}"},
                    {label: "Address2", value: "{{Address2}}"},
                    {label: "City", value: "{{City}}"},
                    {label: "State", value: "{{State}}"},
                    {label: "Zip", value: "{{Zip}}"},
                    {label: "County", value: "{{County}}"},
                    {label: "Member Email", value: "{{MemberEmail}}"},
                    {label: "Home Number", value: "{{HomeNumber}}"},
                    {label: "Work Number", value: "{{WorkNumber}}"},
                    {label: "Mobile Number", value: "{{MobileNumber}}"},
                    {label: "Date Of Birth", value: "{{DateOfBirth}}"},
                    {label: "DTMF", value: "{{DTMF}}"},
                    {label: "Employer 1", value: "{{Employer1}}"},
                    {label: "Employer 2", value: "{{Employer2}}"},
                    {label: "AdditionalEmails", value: "{{AdditionalEmails}}"},
                    {label: "Password", value: "{{Password}}"}
                ]
            }
        ]
    }
);


class QuillEditor extends Component {
    constructor(props, context) {
        super(props, context);

        this.onToolbarClick = this.onToolbarClick.bind(this);
        this.onChangeSelection = this.onChangeSelection.bind(this);
        this.onSourceChange = this.onSourceChange.bind(this);

        this.lastSelectedRange = 0;
    }

    componentDidUpdate() {
        if (this.placeholderSelector) {
            this.placeholderSelector.removeEventListener("change", this.onToolbarClick);
        }

        let selectorList = document.querySelectorAll('select[title=Placeholders]');

        if (selectorList.length === 1) {
            this.placeholderSelector = selectorList[0];

            this.placeholderSelector.addEventListener("change", this.onToolbarClick);
        }
    }

    onSourceChange(value) {
        const { onChange } = this.props.input;

        onChange(value);
    }

    onToolbarClick(event) {
        var self = this;
        var selectedValue = event.currentTarget.value;

        if (selectedValue) {
            console.log(selectedValue);

            var editor = self.refs.myeditor.getEditor();
            var index = 0;

            if (this.lastSelectedRange) {
                index = this.lastSelectedRange.start;
            }

            editor.insertText(index, selectedValue);

            event.currentTarget.selectedIndex = 0;
        }
    }

    onChangeSelection(range, source, editor) {
        const { onFocus, onBlur } = this.props.input;
        if (range) {
            onFocus();
            this.lastSelectedRange = range;
        } else{
            onBlur();
        }

        console.log("range: " + range);
    }

    render() {
        const { value } = this.props.input;

        return (
            <ReactQuill ref="myeditor"  theme='snow' value={value} onChange={this.onSourceChange} onChangeSelection={this.onChangeSelection}>
                <ReactQuill.Toolbar key="toolbar" ref="toolbar" items={toolbarItems} onClick={this.onToolbarClick}>
                </ReactQuill.Toolbar>
                <div key="editor" ref="editor" className="quill-contents" dangerouslySetInnerHTML={{__html:value}} />
            </ReactQuill>
        )

    }
}


export default QuillEditor;
